import { FC } from 'react';
import 'twin.macro';
import 'styled-components/macro';

import { TextButton } from '../../../atoms/button/Button';
import { Icon } from '../../../atoms/icon/Icon';

export interface MenuButtonProps {
  onClick?: () => void;
  open?: boolean;
}

export const MenuButton: FC<MenuButtonProps> = ({ open, ...props }) => (
  <TextButton tw="sm:hidden px-0" {...props}>
    <Icon tw="text-xl" aria-label={open ? 'Close menu' : 'Open menu'} name={open ? 'remove' : 'menu'} />
  </TextButton>
);
